export default __webpack_public_path__ + "components/leaflet/static/placeholder-icon-0f1c1ce20e0dba02976c0d3af9d42250.svg";